const styleOverrides = {};

export default styleOverrides;
